import React from 'react';
import styled from 'styled-components';
import { Container, Flex, Hide, getPaletteColor } from 'pcln-design-system';
import CalendarCard from '../CalendarCard';
import Month from '../Month';
import Footer from '../Footer';
import useCalendar from '../useCalendar';
const LeftAlignedContainer = /*#__PURE__*/styled(Container).withConfig({
  displayName: "CalendarRoot__LeftAlignedContainer",
  componentId: "sc-fgjcji-0"
})(["", " &&&{margin-left:unset;margin-right:unset;z-index:4;", "{width:auto;}}"], props => props.isFixedPositionedCalendar && 'position: fixed;', props => props.theme.mediaQueries[1]);
const CalendarFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CalendarRoot__CalendarFlex",
  componentId: "sc-fgjcji-1"
})(["&&&{position:relative;z-index:4;", "{", "}", ";}"], props => props.theme.mediaQueries[1], props => !props.isMobile && `
        box-shadow: ${props.hasBoxShadow ? props.theme.shadows['overlay-lg'] : 'none'};
      `, props => !props.isMobile ? `background-color: ${getPaletteColor('background.lightest')(props)}` : '');
/** @public */
function CalendarRoot({
  className
}) {
  const {
    animateScroll,
    boxShadow,
    calendarRef,
    calendarWrapperStyles,
    dayGap,
    dayWrapperStyleOverride,
    dayWithRoundedCorners,
    didUseKeyNavigation,
    displayYear,
    endDate,
    firstValidMonth,
    footer,
    highlightedDates,
    hoveredDate,
    isFixedPositionedCalendar,
    isMobile,
    locale,
    maxDate,
    maxSelectableDate,
    minDate,
    monthIndex,
    months,
    monthsToShow,
    monthWidth,
    roundedCorners = true,
    scrollToMonth,
    selectTwoDates,
    showHoveredDates = typeof window !== 'undefined' && window.innerWidth > 640,
    startDate,
    useDefaultFooter,
    use2024DesignSeti,
    handleKeyNav,
    onDayClicked,
    onDayHovered,
    onDismiss,
    onDisplayMonthsChange,
    setSelectedDayRef
  } = useCalendar();
  const isTouch = document ? 'ontouchstart' in document.documentElement : true;
  const hasFooterBoxShadow = boxShadow && footer || useDefaultFooter ? boxShadow : null;
  return React.createElement(LeftAlignedContainer, {
    className: className,
    height: isMobile ? '100%' : 'auto',
    maxWidth: !isMobile && monthWidth * monthsToShow,
    "data-testid": 'calendar-root',
    isFixedPositionedCalendar: isFixedPositionedCalendar
  }, React.createElement(CalendarFlex, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    flexDirection: 'column-reverse',
    hasBoxShadow: hasFooterBoxShadow,
    isMobile: isMobile,
    height: isMobile ? '100%' : 'auto'
  }, !isMobile && React.createElement(Hide, {
    xs: true,
    sm: true
  }, React.createElement(Flex, {
    width: monthsToShow * monthWidth
  }, footer && !useDefaultFooter && React.cloneElement(footer, {
    dismissCalendar: onDismiss || undefined,
    roundedCorners: roundedCorners || undefined
  }), useDefaultFooter && React.createElement(Footer, {
    roundedCorners: roundedCorners,
    use2024DesignSeti: use2024DesignSeti,
    dismissCalendar: onDismiss
  }))), React.createElement(CalendarCard, {
    animateScroll: animateScroll,
    boxShadow: boxShadow && !footer && !useDefaultFooter ? boxShadow : null,
    calendarWrapperStyles: calendarWrapperStyles,
    firstValidMonth: firstValidMonth,
    hoveredDate: hoveredDate,
    isMobile: isMobile,
    maxSelectableDate: maxSelectableDate,
    monthsToShow: monthsToShow,
    monthWidth: monthWidth,
    roundedCorners: !isMobile && roundedCorners,
    scrollToMonth: scrollToMonth,
    useDefaultFooter: useDefaultFooter,
    keyNavHandler: handleKeyNav,
    onDisplayMonthsChange: onDisplayMonthsChange,
    onDismiss: onDismiss,
    setCalendarRef: calendarRef
  }, months.map((month, i) => React.createElement(Month, {
    ...month,
    currentMonthIndex: monthIndex,
    dayGap: dayGap,
    dayWrapperStyleOverride: dayWrapperStyleOverride,
    dayWithRoundedCorners: dayWithRoundedCorners,
    didUseKeyNavigation: didUseKeyNavigation,
    displayYear: displayYear,
    endDate: endDate,
    hoveredDate: hoveredDate,
    highlightedDates: highlightedDates,
    index: i,
    isMobile: isMobile,
    isTouch: isTouch,
    key: i,
    locale: locale,
    maxDate: maxDate,
    maxSelectableDate: maxSelectableDate,
    minDate: minDate,
    monthsToShow: monthsToShow,
    monthWidth: monthWidth,
    showHoveredDates: selectTwoDates || showHoveredDates,
    startDate: startDate,
    use2024DesignSeti: use2024DesignSeti,
    onDayClicked: onDayClicked,
    onDayHovered: onDayHovered,
    setSelectedDayRef: setSelectedDayRef
  })))));
}
export default CalendarRoot;